import { Popover, useIsMobileScreenSize } from '@buffer-mono/popcorn'

import { HashtagGroupManager } from '../HashtagGroupManager'

import styles from './HashtagGroupPopover.module.css'

import type { JSX } from 'react'

export interface HashtagGroupPopoverProps {
  onInsertHashtag?: (text: string) => void
  children: React.ReactNode
}

export const HashtagGroupPopover = ({
  onInsertHashtag,
  children,
}: HashtagGroupPopoverProps): JSX.Element => {
  const isMobileScreenSize = useIsMobileScreenSize()

  return (
    <Popover>
      <Popover.Trigger>{children}</Popover.Trigger>
      <Popover.Content
        className={styles.popoverContent}
        side={isMobileScreenSize ? 'top' : 'right'}
        align="start"
      >
        <HashtagGroupManager onInsertHashtag={onInsertHashtag} />
      </Popover.Content>
    </Popover>
  )
}
